import * as React from "react";

const FairHousingLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    width="26px" 
    fill="none"
    className="svg-overlay large-device-svg" 
    viewBox="0 0 26 20" 
    {...props} 
  >
    <g
      id="Designs-v2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(-427.000000, -4899.000000)"
        fill="#85929E"
        fillRule="nonzero"
      >
        <g id="Group-8" transform="translate(122.000000, 4022.000000)">
          <path d="M305,884.889725 L317.983279,877 L331,884.889562 L331,887.584312 L329.097639,887.584312 L329.097639,897 L306.869087,897 L306.869087,887.584312 L305,887.584312 L305,884.889725 Z M317.983783,880.146736 L309.806655,884.984536 L309.806655,894.140148 L326.194353,894.140148 L326.194353,884.951843 L317.983783,880.146736 L317.983783,880.146736 Z M313.477439,889.63108 L322.555836,889.63108 L322.555836,892.163508 L313.477439,892.163508 L313.477439,889.63108 L313.477439,889.63108 Z M313.477439,886.218874 L322.555836,886.218874 L322.555836,888.718772 L313.477439,888.718772 L313.477439,886.218874 L313.477439,886.218874 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default FairHousingLogo;
